/**
 * #19167 (#19153 L1) — chỉ được nhận khám (check-in) một lịch hẹn của HÔM NAY.
 *
 * Check-in dời giờ hẹn về "bây giờ" nhưng số thứ tự phòng lấy từ dãy của ngày hẹn, nên check-in
 * hôm nay một lịch ngày mai làm trùng số với người khác cùng phòng. Backend từ chối 422
 * (`check_in_wrong_day`); màn hình chặn trước để lễ tân biết phải dời lịch.
 *
 * So theo NGÀY GIỜ VIỆT NAM, không theo múi giờ của trình duyệt: một máy đặt sai múi giờ không được
 * cho check-in lệch ngày, và cũng không được chặn nhầm lịch hôm nay.
 */
const VN_DAY = new Intl.DateTimeFormat("en-CA", {
  timeZone: "Asia/Ho_Chi_Minh",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
});

export function vnDay(iso: string | Date): string {
  return VN_DAY.format(typeof iso === "string" ? new Date(iso) : iso);
}

export function isCheckInDay(startAt: string, now: Date = new Date()): boolean {
  return vnDay(startAt) === vnDay(now);
}
